import {all} from 'redux-saga/effects'
import apiDataSaga from "./api-data-saga";

function* rootSaga() {
    yield all([...apiDataSaga()])
}

export default rootSaga